import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import 'hamburgers/dist/hamburgers.css'

import Button from '../buttons/Button'

import MobileDropdown from './MobileDropdown'

const MobileNavClass = css`
  color: #232323;
`

const NavClass = css`
  transition: .25s ease-out;
  position: absolute;
  left: 0;
  top: 5rem;
  right: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  height: 0;
  z-index: 0;
  transform: translateY(-1300px);

  &.is-active {
    height: calc(100vh - 80px);
    overflow-y: scroll;
    transform: translateY(0);
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

const MobileNavClassMenu = css`
  position: relative;
  z-index: 100;
`

const NavItem = styled.li`
  text-align: left;
  padding: 0.4rem 1rem;
  border-bottom: 1px solid #F8F8F8;
  background: #fff;

  &:last-child {
    border: none;
    padding: 2rem;
  }

  @media (min-width: 800px) {
    padding: 1rem;
    text-align: center;
  }
`

// {props.links.map(link => (
//   <li key={link.to}>
//     <Button anchor navLink to={link.to}>{link.label}</Button>
//   </li>
// ))}

class MobileNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      toggled: {}
    }

    
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.menuRef.contains(event.target)) {      
      this.setState({ isOpen: false });
    }
  }

  toggleNav() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    return (
      <div className={MobileNavClass}>
        <button ref={ref => { this.menuRef = ref }} onClick={() => this.toggleNav()} className={`${MobileNavClassMenu} hamburger hamburger--spin ${this.state.isOpen ? 'is-active' : ''}`} type="button">
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
        <ul ref={ref => { this.wrapperRef = ref }} className={`${NavClass} ${this.state.isOpen ? 'is-active' : ''}`}>
          {this.props.links.map((link, idx) => {
            if (link.links) {
              return (
                <NavItem key={idx}>
                  <MobileDropdown
                    key={link.label}
                    nav={link}
                    onNavigate={() => this.toggleNav()}
                  />
                </NavItem>
              )
            } else
            if (link.button) {
              return null
            } 
            else {
              return (
              <NavItem key={idx}>
                <Button mobile anchor navLink to={link.to} onClick={() => this.toggleNav()}>{link.label}</Button>
              </NavItem>
              )
            }
          })}
          <NavItem>
            <ButtonContainer>
              <Button to={'https://app.trywhistle.com/login'} flat horizontalPadding external>Login</Button>
            </ButtonContainer>
          </NavItem>
        </ul>
      </div>
    )
  }
}
 
export default MobileNav;


// WEBPACK FOOTER //
// ./src/components/header/MobileNav.js